import { render, staticRenderFns } from "./carOwnerDetails.vue?vue&type=template&id=6409f588&scoped=true&"
import script from "./carOwnerDetails.vue?vue&type=script&lang=js&"
export * from "./carOwnerDetails.vue?vue&type=script&lang=js&"
import style0 from "./carOwnerDetails.vue?vue&type=style&index=0&id=6409f588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409f588",
  null
  
)

export default component.exports